import React from "react";

// reactstrap components
import {
  Button,
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

// Core Components
import Countdown from "../content/Countdown";

const LandingPageHeader = () => {
  return (
    <>
      <div className="page-header header-filter">
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" + require("assets/img/logo/Logo.jpg") + ")",
          }}
        ></div>
        <Container className="text-center">
          <Row>
            <Col className="mx-auto" lg="7">
              <h1 className="display-3 text-white">100 for Hannah</h1>
              {/* <h1 className="display-3 text-white">Run for Hope</h1> */}
            </Col>
          </Row>
          <Countdown
            timeTillDate="03 20 2021, 5:00 am"
            timeFormat="MM DD YYYY, h:mm a"
          />
        </Container>
      </div>
    </>
  );
};

export default LandingPageHeader;
